import { getCalendarEntry, getCalendarGroups } from '../selectors/calendarsCacheSelectors';
import Calendar from '../store/schema/Calendar';
import { findInArray } from 'owa-calendar-data-utils/lib/findInArray';

const GROUP_CALENDAR_GROUP_ID = 'Groups';

/**
 * Determines the user's primarySmtpAddress for a given user or group calendar
 */
export default function getCalendarMailboxId(calendar: Calendar): string {
    const groups = findInArray(
        getCalendarGroups(),
        group => group.ItemId.Id === GROUP_CALENDAR_GROUP_ID
    );

    return isGroupCalendar(calendar) && groups
        ? groups.item.id.mailboxInfo.primarySmtpAddress
        : calendar.id.mailboxInfo.primarySmtpAddress;
}

export function isGroupCalendar(calendar: Calendar): boolean {
    const calendarEntry = getCalendarEntry(calendar);
    return !!calendarEntry && calendarEntry.IsGroupMailboxCalendar;
}
